import allActions from '../../actions/product_builder';
import typography from '../../styles/typography.module.css';
import Paper from '@mui/material/Paper';
import { Box, Typography, Button, ButtonGroup } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/material';
import { useSelector, batch } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import buttons from '../../styles/buttons.module.css';

export const CarePlan = () => {
    const { t } = useTranslation();
    const theme = useTheme();

    const dispatch = useDispatch();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const currency = useSelector((state) => state.shopifyReducer.ciems[0]?.currency || '$');
    const currentModel = useSelector((state) => state.rootReducer.currentModel.currentModel);

    const careExtensionPrice = currentModel?.carePlan;

    const isCarePlanSelected = useSelector(
        (state) => state.rootReducer.finalizeForm.carePlanSelected
    );

    return (
        <Paper
            elevation={0}
            style={{
                maxHeight: '98%',
                overflow: 'auto',
                direction: 'ltr',
                padding: isMobile ? '8px' : '16px'
            }}>
            <h4
                className={typography.headerTitle}
                style={{
                    fontSize: isMobile ? '1.3rem' : '1.5rem',
                    marginBottom: isMobile ? '12px' : '16px',
                    textAlign: 'center'
                }}>
                {t('menu.care_plan', 'Care Plan')}
            </h4>
            <Box>
                <Typography
                    variant="body1"
                    style={{
                        marginBottom: isMobile ? '16px' : '20px',
                        lineHeight: '1.5',
                        fontSize: isMobile ? '0.9rem' : '1rem',
                        textAlign: 'left',
                        color: '#555',
                        padding: isMobile ? '0 4px' : '0 8px'
                    }}>
                    {t(
                        'care_extension.description',
                        'The 64 Audio Care Plan extends your coverage and adds premium protection throughout the life of your Custom In-Ear Monitors (CIEMs). It is designed to eliminate unexpected repair costs and provide long-term peace of mind.'
                    )}
                </Typography>

                <Box
                    style={{
                        border: '2px solid #e8f4f8',
                        borderRadius: isMobile ? '6px' : '8px',
                        padding: isMobile ? '16px' : '20px',
                        marginBottom: isMobile ? '12px' : '16px',
                        backgroundColor: '#f0f8ff'
                    }}>
                    <Typography
                        variant="h6"
                        style={{
                            fontSize: isMobile ? '0.95rem' : '1.1rem',
                            fontWeight: '600',
                            marginBottom: isMobile ? '12px' : '16px',
                            textAlign: 'center',
                            color: '#1976d2'
                        }}>
                        {t('care_extension.add_option', 'Add 64 Audio Care Extension')} - {currency}
                        {careExtensionPrice}
                    </Typography>

                    <ButtonGroup
                        variant="contained"
                        fullWidth
                        orientation={isMobile ? 'vertical' : 'horizontal'}
                        style={{
                            gap: isMobile ? '8px' : '12px',
                            boxShadow: 'none',
                            borderRadius: '30px',
                            flexDirection: isMobile ? 'column' : 'row'
                        }}>
                        <Button
                            style={{
                                borderRadius: '30px'
                            }}
                            className={
                                isCarePlanSelected === 'Yes Care Plan Added'
                                    ? buttons.bntCarPlanSelected
                                    : buttons.bntCarPlan
                            }
                            onClick={() => {
                                batch(() => {
                                    dispatch(
                                        allActions.finalizeAction.setCarePlanSelected(
                                            'Yes Care Plan Added'
                                        )
                                    );
                                    dispatch(
                                        allActions.priceActions.setCarePlanPrice({
                                            price: careExtensionPrice
                                        })
                                    );
                                });
                            }}>
                            {isCarePlanSelected === 'Yes Care Plan Added' ? '✓ ' : ''}
                            {t('care_extension.add_plan', 'Add Care Plan')}
                        </Button>

                        <Button
                            style={{
                                borderRadius: '30px'
                            }}
                            className={
                                isCarePlanSelected === 'No Care Plan Added'
                                    ? buttons.bntCarPlanSelected
                                    : buttons.bntCarPlan
                            }
                            onClick={() => {
                                batch(() => {
                                    dispatch(
                                        allActions.finalizeAction.setCarePlanSelected(
                                            'No Care Plan Added'
                                        )
                                    );
                                    dispatch(
                                        allActions.priceActions.setCarePlanPrice({ price: 0 })
                                    );
                                });
                            }}>
                            {isCarePlanSelected === 'No Care Plan Added' ? '✓ ' : ''}
                            {t('care_extension.skip_plan', 'Skip Care Plan')}
                        </Button>
                    </ButtonGroup>

                    <Typography
                        variant="body2"
                        style={{
                            fontSize: isMobile ? '0.8rem' : '0.85rem',
                            color: '#1565c0',
                            fontWeight: '500',
                            marginTop: isMobile ? '12px' : '16px',
                            textAlign: 'center',
                            padding: isMobile ? '8px' : '10px',
                            backgroundColor: isCarePlanSelected === 'add' ? '#e3f2fd' : '#f5f5f5',
                            borderRadius: isMobile ? '4px' : '6px'
                        }}>
                        {isCarePlanSelected === undefined ? (
                            <Typography variant="body2" style={{ color: '#d62915' }}>
                                {t('care_extension.plan_not_selected', 'Please select an option')}
                            </Typography>
                        ) : isCarePlanSelected === 'Yes Care Plan Added' ? (
                            t('care_extension.plan_added', 'Care Plan will be added to your order')
                        ) : (
                            t(
                                'care_extension.plan_skipped',
                                'Care Plan will not be included in your order'
                            )
                        )}
                    </Typography>
                </Box>
                <Typography
                    variant="body2"
                    style={{
                        fontSize: isMobile ? '0.75rem' : '0.8rem',
                        color: '#666',
                        fontStyle: 'italic',
                        marginBottom: isMobile ? '8px' : '10px',
                        lineHeight: '1.4',
                        textAlign: 'center',
                        padding: isMobile ? '0 8px' : '0 16px'
                    }}>
                    {t(
                        'care_extension.disclaimer',
                        'Care Extension must be purchased with your original order. Cannot be added later.'
                    )}
                </Typography>
                <Box
                    style={{
                        border: '1px solid #e0e0e0',
                        borderRadius: isMobile ? '8px' : '12px',
                        padding: isMobile ? '12px' : '20px',
                        marginBottom: isMobile ? '16px' : '20px',
                        backgroundColor: '#ffffff',
                        boxShadow: isMobile
                            ? '0 1px 4px rgba(0,0,0,0.1)'
                            : '0 2px 8px rgba(0,0,0,0.1)'
                    }}>
                    <Typography
                        variant="h6"
                        style={{
                            marginBottom: isMobile ? '12px' : '16px',
                            fontWeight: '700',
                            fontSize: isMobile ? '1rem' : '1.1rem',
                            textAlign: 'left',
                            color: '#1976d2'
                        }}>
                        {t('care_extension.coverage_title', "What's Covered")}
                    </Typography>

                    {/* Extended Warranty Sub-section */}
                    <Box
                        style={{
                            marginBottom: isMobile ? '12px' : '16px'
                        }}>
                        <Box
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginBottom: isMobile ? '6px' : '8px'
                            }}>
                            <Box
                                style={{
                                    width: '6px',
                                    height: '6px',
                                    borderRadius: '50%',
                                    backgroundColor: '#1976d2',
                                    marginRight: '10px'
                                }}
                            />
                            <Typography
                                variant="subtitle1"
                                style={{
                                    fontWeight: '600',
                                    fontSize: isMobile ? '0.85rem' : '0.95rem',
                                    color: '#333',
                                    textAlign: 'left'
                                }}>
                                {t('care_extension.warranty_title', '4-Year Extended Warranty')}
                            </Typography>
                        </Box>
                        <Typography
                            style={{
                                fontSize: isMobile ? '0.8rem' : '0.85rem',
                                lineHeight: '1.5',
                                color:
                                    isCarePlanSelected !== 'Yes Care Plan Added'
                                        ? 'rgba(0, 0, 0, 0.26)'
                                        : 'rgba(0, 0, 0, 1)',
                                marginLeft: isMobile ? '12px' : '16px',
                                textAlign: 'left'
                            }}>
                            {t(
                                'care_extension.warranty_1',
                                'Extends your CIEM warranty from 2 years to 4 years'
                            )}
                        </Typography>
                    </Box>

                    {/* Unlimited Repairs Sub-section */}
                    <Box style={{ marginBottom: isMobile ? '16px' : '20px' }}>
                        <Box
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginBottom: isMobile ? '6px' : '8px'
                            }}>
                            <Box
                                style={{
                                    width: '6px',
                                    height: '6px',
                                    borderRadius: '50%',
                                    backgroundColor: '#1976d2',
                                    marginRight: '10px'
                                }}
                            />
                            <Typography
                                variant="subtitle1"
                                style={{
                                    fontWeight: '600',
                                    fontSize: isMobile ? '0.85rem' : '0.95rem',
                                    color: '#333',
                                    textAlign: 'left'
                                }}>
                                {t('care_extension.repairs_title', 'Unlimited Repairs')}
                            </Typography>
                        </Box>
                        <Box style={{ marginLeft: isMobile ? '12px' : '16px' }}>
                            <Typography
                                style={{
                                    fontSize: isMobile ? '0.8rem' : '0.85rem',
                                    lineHeight: '1.5',
                                    color:
                                        isCarePlanSelected !== 'Yes Care Plan Added'
                                            ? 'rgba(0, 0, 0, 0.26)'
                                            : 'rgba(0, 0, 0, 1)',
                                    marginBottom: '6px',
                                    textAlign: 'left'
                                }}>
                                {t(
                                    'care_extension.repairs_1',
                                    'All repairable issues with your CIEMs are fully covered for the duration of the plan.'
                                )}
                            </Typography>
                            <Typography
                                style={{
                                    fontSize: isMobile ? '0.8rem' : '0.85rem',
                                    lineHeight: '1.5',
                                    color:
                                        isCarePlanSelected !== 'Yes Care Plan Added'
                                            ? 'rgba(0, 0, 0, 0.26)'
                                            : 'rgba(0, 0, 0, 1)',
                                    textAlign: 'left'
                                }}>
                                {t(
                                    'care_extension.repairs_2',
                                    'Up to 3 cable replacements when cables fail under normal use'
                                )}
                            </Typography>
                        </Box>
                    </Box>

                    {/* Remold Coverage Sub-section */}
                    <Box style={{ marginBottom: isMobile ? '16px' : '20px' }}>
                        <Box
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginBottom: isMobile ? '6px' : '8px'
                            }}>
                            <Box
                                style={{
                                    width: '6px',
                                    height: '6px',
                                    borderRadius: '50%',
                                    backgroundColor: '#1976d2',
                                    marginRight: '10px'
                                }}
                            />
                            <Typography
                                variant="subtitle1"
                                style={{
                                    fontWeight: '600',
                                    fontSize: isMobile ? '0.85rem' : '0.95rem',
                                    color: '#333',
                                    textAlign: 'left'
                                }}>
                                {t('care_extension.remold_title', 'Remold Coverage')}
                            </Typography>
                        </Box>
                        <Typography
                            style={{
                                fontSize: isMobile ? '0.8rem' : '0.85rem',
                                lineHeight: '1.5',
                                color:
                                    isCarePlanSelected !== 'Yes Care Plan Added'
                                        ? 'rgba(0, 0, 0, 0.26)'
                                        : 'rgba(0, 0, 0, 1)',
                                marginLeft: isMobile ? '12px' : '16px',
                                textAlign: 'left'
                            }}>
                            {t(
                                'care_extension.remold_1',
                                'Covers up to 2 remolds during the 4-year term if your CIEM fit changes or you break your CIEM shell.'
                            )}
                        </Typography>
                    </Box>

                    {/* Professional Deep Cleanings Sub-section */}
                    <Box>
                        <Box
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginBottom: isMobile ? '6px' : '8px'
                            }}>
                            <Box
                                style={{
                                    width: '6px',
                                    height: '6px',
                                    borderRadius: '50%',
                                    backgroundColor: '#1976d2',
                                    marginRight: '10px'
                                }}
                            />
                            <Typography
                                variant="subtitle1"
                                style={{
                                    fontWeight: '600',
                                    fontSize: isMobile ? '0.85rem' : '0.95rem',
                                    color: '#333',
                                    textAlign: 'left'
                                }}>
                                {t('care_extension.service_title', 'Professional Deep Cleanings')}
                            </Typography>
                        </Box>
                        <Typography
                            style={{
                                fontSize: isMobile ? '0.8rem' : '0.85rem',
                                lineHeight: '1.5',
                                color:
                                    isCarePlanSelected !== 'Yes Care Plan Added'
                                        ? 'rgba(0, 0, 0, 0.26)'
                                        : 'rgba(0, 0, 0, 1)',
                                marginLeft: isMobile ? '12px' : '16px',
                                textAlign: 'left'
                            }}>
                            {t(
                                'care_extension.service_1',
                                'Includes 1 deep cleaning per year during the 4-year term to keep your CIEMs looking and sounding their best.'
                            )}
                        </Typography>
                    </Box>
                </Box>
                <Box
                    style={{
                        border: '2px solid #e8f4f8',
                        borderRadius: isMobile ? '6px' : '8px',
                        padding: isMobile ? '12px' : '16px',
                        marginBottom: isMobile ? '16px' : '20px',
                        backgroundColor: '#f8fcff'
                    }}>
                    <Typography
                        variant="h6"
                        style={{
                            marginBottom: isMobile ? '10px' : '12px',
                            fontWeight: 'bold',
                            fontSize: isMobile ? '0.95rem' : '1rem',
                            textAlign: 'left',
                            color: '#1976d2'
                        }}>
                        {t('care_extension.how_it_works_title', 'How It Works')}
                    </Typography>

                    <Box
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: isMobile ? '8px' : '10px'
                        }}>
                        <Box
                            style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: isMobile ? '8px' : '10px',
                                marginBottom: isMobile ? '6px' : '4px'
                            }}>
                            <Box
                                style={{
                                    width: '4px',
                                    height: '4px',
                                    borderRadius: '50%',
                                    backgroundColor: '#1976d2',
                                    marginTop: isMobile ? '6px' : '5px',
                                    flexShrink: 0
                                }}
                            />
                            <Typography
                                style={{
                                    fontSize: isMobile ? '0.8rem' : '0.85rem',
                                    lineHeight: '1.4',
                                    color: '#555'
                                }}>
                                <strong
                                    style={{
                                        color: '#1976d2',
                                        fontSize: isMobile ? '0.8rem' : '0.85rem'
                                    }}>
                                    {t('care_extension.step1_title', '1. Purchase with Order')}:
                                </strong>{' '}
                                {t(
                                    'care_extension.step1_desc',
                                    'Care Plan must be added to your original CIEM order'
                                )}
                            </Typography>
                        </Box>

                        <Box
                            style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: isMobile ? '8px' : '10px'
                            }}>
                            <Box
                                style={{
                                    width: '4px',
                                    height: '4px',
                                    borderRadius: '50%',
                                    backgroundColor: '#1976d2',
                                    marginTop: isMobile ? '6px' : '5px',
                                    flexShrink: 0
                                }}
                            />
                            <Typography
                                style={{
                                    fontSize: isMobile ? '0.8rem' : '0.85rem',
                                    lineHeight: '1.4',
                                    color: '#555'
                                }}>
                                <strong
                                    style={{
                                        color: '#1976d2',
                                        fontSize: isMobile ? '0.8rem' : '0.85rem'
                                    }}>
                                    {t('care_extension.step3_title', '2. Get Coverage')}:
                                </strong>{' '}
                                {t(
                                    'care_extension.step3_desc',
                                    "Contact us for any issues - we'll handle the rest"
                                )}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Paper>
    );
};
